import { Trophy } from "lucide-react";

interface Sponsor {
  name: string;
  logo: string;
}

interface ProfileSponsorsProps {
  sponsors: Sponsor[];
}

const ProfileSponsors = ({ sponsors }: ProfileSponsorsProps) => {
  if (sponsors.length === 0) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Trophy className="w-5 h-5 text-purple-500" />
        <h3 className="font-medium text-gray-900">Sponsors</h3>
      </div>
      <div className="pl-7 flex gap-4">
        {sponsors.map((sponsor, index) => (
          <div key={index} className="text-center">
            <div className="w-12 h-12 bg-purple-50 rounded-full flex items-center justify-center">
              <img src={sponsor.logo} alt={sponsor.name} className="w-8 h-8" />
            </div>
            <span className="text-sm text-purple-700">{sponsor.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileSponsors;